import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';  
import auth from './../service/auth';
import estadoEgreso from './modules/estadoEgreso.store';
import routes from '../routes'; 

 
Vue.use(Vuex) 

export default new Vuex.Store({
    state: {  
        btn_session: 'btn btn-success btn-sm',
        expire_at: 0,
        cognitoInfo: {},
        userPerfil: {},
        loggedIn: false,
        loadingState: true,
        errorLoadingState: false
    
    },
    mutations: {
 
        setTimeAt(state, payload) {
            state.expire_at = payload
        },
        async setInfoCognito(state, data) {
            state.expire_at = await auth.getExpiracionDiferencia()
            setInterval(async ()=>{ 
                state.btn_session = `btn btn-success btn-sm`
                state.expire_at = await auth.getExpiracionDiferencia()
                if( state.expire_at <= 0 )
                {
                    routes.push('/auth/logout')
                }

                if( Math.round(state.expire_at/60) < 5 )
                {
                    state.btn_session = `btn btn-warning btn-sm`
                } 

            },1000)
            state.cognitoInfo = data;
        },
        setUserPerfil(state, data) {
            state.userPerfil = data
        },

        setLoggedIn(state, valor) {
            state.loggedIn = valor;
        },    
            setLoggedOut(state) {
            state.loggedIn = false;
            state.cognitoInfo = {};
            state.userPerfil = {};
        }
    },
    getters:{
        tiempo_restante:(state)=>{
            const segundos = state.expire_at 
            return `Sesión expira en: ${ Math.round(segundos/60) } minutos`  
        },
        getPerfil : (state) =>{
            return state.userPerfil
        }
    },
    actions: { 
        async refresh_token(state)
        {

           auth.refresh()
           
        },
        async getUserPerfil(state)
        {
            const url = `${process.env.VUE_APP_API_SERVEL}/administracion/login `
            return axios.get(url).then(response => { 
                console.log('response:::', response.data);
                state.commit('setUserPerfil', response.data.data) 
                return response.data.data;
            });
        },
        getUserInfo(state)
        {
            var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
            const USERINFO_URL = 'https://'+auth.auth.getAppWebDomain() + '/oauth2/userInfo';
            var requestData = {
                headers: {
                    'Authorization': 'Bearer '+ jwtToken
                }
            }
            console.log('aqui es donde entra::::');
            return axios.get(USERINFO_URL, requestData).then(response => { 


                state.commit('setInfoCognito', response.data);

                return response.data;
        });
  }
     

  },
  modules:{
    estadoEgreso,
  }
})
